import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable } from '@angular/core';
import { CustomerOverview, ReportStyle, NewCustomer, UpdateCustomer, JobSiteType, ReportRetrieveOptions, CountryVM } from '../models/customer.model';
import { Tuple } from '../models/tuple.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
@Injectable()
export class CustomerServiceIdentity {
    private readonly GetAllCustomersApiAddress = 'api/admin/GetAllCustomersForUser';
    private readonly GetJobsiteTypesApiAddress = 'api/admin/getJobsiteTypes';
    private readonly GetReportStylesForCustomer = 'api/admin/getReportStylesForCustomer';
    private readonly GetQuoteReportStylesForCustomer = 'api/admin/GetQuoteReportStyleForCustomer';
    private readonly getReportStyleForCustomerByDealerGroupApi = 'api/admin/getReportStyleForCustomerByDealerGroup';
    private readonly getQuoteReportStyleForCustomerByDealerGroupApi = 'api/admin/GetQuoteReportStyleForCustomerByDealerGroup';
    private readonly AddNewCustomerApiAddress = 'api/admin/AddNewCustomer';
    private readonly UpdateCustomerApiAddress = 'api/admin/UpdateCustomer';
    private readonly GetAllCustomersForDealershipApiAddress = 'api/admin/GetAllCustomersForDealership';
    private readonly GetCustomerDetailsApiAddress = 'api/admin/GetCustomerDetails';
    private readonly GetAllCountryApiAddress = 'api/admin/GetAllCountries';

    private readonly GetRopeReportStylesForCustomer = 'api/admin/getRopeReportStylesForCustomer';

    private readonly GetWearReportStylesForCustomer = 'api/admin/getWearReportStylesForCustomer';
    private readonly GetWsreReportStylesForCustomer = 'api/admin/getWsreReportStylesForCustomer';

    private readonly getRopeReportStyleForCustomerByDealerGroupApi = 'api/admin/getRopeReportStyleForCustomerByDealerGroup';
    private readonly getWearReportStyleForCustomerByDealerGroupApi = 'api/admin/getWearReportStyleForCustomerByDealerGroup';
    private readonly getWsreReportStyleForCustomerByDealerGroupApi = 'api/admin/getWsreReportStyleForCustomerByDealerGroup';
    private readonly CheckThermography = 'api/admin/CheckThermography';
    private readonly ValidateCustomerName='api/admin/CheckValidationCustomerName';
    private readonly CheckUserType='api/admin/CheckUCUserType';


    private readonly ValidateCustomerNameEdit='api/admin/EditCustomerCheckValidationCustomerName';


    constructor(private _http: HttpClient) { }

    public CheckThermographyEnable(): Observable<boolean> {
        // return this._http.get(this.GetAuthorizedUserAccessTypesApiAddress).share().map(
        //     (response: Response) => <AuthorizedUserAccessType[]>response.json()).catch(this.handleError);
        return this._http.get<boolean>(this.CheckThermography).pipe(catchError(this.handleError));
    }
    public getAllCustomers(): Observable<CustomerOverview[]> {
        // return this._http.get(this.GetAllCustomersApiAddress).share().map(
        //     (response: Response) => <CustomerOverview[]>response.json()).catch(this.handleError);
            return this._http.get<CustomerOverview[]>(this.GetAllCustomersApiAddress).pipe(catchError(this.handleError));
    }

  public getCustomerList(): Observable<CustomerSelectItem[]> {
    return this._http.get<CustomerSelectItem[]>("api/admin/GetCustomerList").pipe(catchError(this.handleError));
    }

    public getAllCustomersForAdminstration(UserRequestModel :any): Observable<CustomerOverview[]> {
        // return this._http.get(this.GetAllCustomersApiAddress).share().map(
        //     (response: Response) => <CustomerOverview[]>response.json()).catch(this.handleError);
            return this._http.post<CustomerOverview[]>(this.GetAllCustomersApiAddress,UserRequestModel).pipe(catchError(this.handleError));
    }

    public getJobsiteTypes(): Observable<JobSiteType[]> {
        // return this._http.get(this.GetJobsiteTypesApiAddress).share().map(
        //     (response: Response) => <JobSiteType[]>response.json()).catch(this.handleError);
            return this._http.get<JobSiteType[]>(this.GetJobsiteTypesApiAddress).pipe(catchError(this.handleError));
    }

    public CheckUCUserType(): Observable<number> {
        return this._http.get<number>(this.CheckUserType).pipe(catchError(this.handleError));
    }
    
    public getCustomerDetails(customerId: number): Observable<NewCustomer> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('customerId', customerId.toString());
        // return this._http.get(this.GetCustomerDetailsApiAddress, { search: params }).share().map(
        //     (response: Response) => <NewCustomer>response.json()).catch(this.handleError);

        const options = {
          params: new HttpParams().set('customerId', customerId.toString())
        };
           return this._http.get<NewCustomer>(this.GetCustomerDetailsApiAddress, options).pipe(catchError(this.handleError));
    }

    public getAllCustomersForDealership(dealershipId: number): Observable<CustomerOverview[]> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('dealershipId', dealershipId.toString());
        // return this._http.get(this.GetAllCustomersForDealershipApiAddress, { search: params }).share().map(
        //     (response: Response) => <CustomerOverview[]>response.json()).catch(this.handleError);
        const options = {
          params: new HttpParams().set('dealershipId', dealershipId.toString())
        };
      return this._http.get<CustomerOverview[]>(this.GetAllCustomersForDealershipApiAddress, options).pipe(catchError(this.handleError));
    }

    public getReportStyleForCustomerByDealership(customerId: number, dealershipId: number, options: ReportRetrieveOptions):
                                                                                                Observable<ReportStyle[]> {
        // let params: URLSearchParams = new URLSearchParams();
        //     params.set('CustomerId', customerId.toString());
        //     params.set('DealershipId', dealershipId.toString());
        // if (options == ReportRetrieveOptions.ConditionReport) {
        //     return this._http.get(this.GetReportStylesForCustomer, { search: params }).share().map(
        //         (response: Response) => <ReportStyle[]>response.json()).catch(this.handleError);
        // }
        // if(options == ReportRetrieveOptions.QuoteReport){
        //     return this._http.get(this.GetQuoteReportStylesForCustomer, { search: params }).share().map(
        //         (response: Response) => <ReportStyle[]>response.json()).catch(this.handleError);
        // }
        const params = {
          params: new HttpParams().set('CustomerId', customerId.toString()).set('DealershipId', dealershipId.toString())
        };

        if (+options === +ReportRetrieveOptions.ConditionReport) {
            return this._http.get<ReportStyle[]>(this.GetReportStylesForCustomer, params).pipe(catchError(this.handleError));
        }

        if (+options === +ReportRetrieveOptions.RopeReport) {
            return this._http.get<ReportStyle[]>(this.GetRopeReportStylesForCustomer, params).pipe(catchError(this.handleError));
        }

        if (+options === +ReportRetrieveOptions.WearReport) {
            return this._http.get<ReportStyle[]>(this.GetWearReportStylesForCustomer, params).pipe(catchError(this.handleError));
        }

        if (+options === +ReportRetrieveOptions.WsreReport) {
            return this._http.get<ReportStyle[]>(this.GetWsreReportStylesForCustomer, params).pipe(catchError(this.handleError));
        }

        if (+options === +ReportRetrieveOptions.QuoteReport) {
            return this._http.get<ReportStyle[]>(this.GetQuoteReportStylesForCustomer, params).pipe(catchError(this.handleError));
        }
    }


    public getReportStyleForCustomerByDealerGroup(dealerGroupId: number, options: ReportRetrieveOptions): Observable<ReportStyle[]> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('dealerGroupId', dealerGroupId.toString());
        // if(options == ReportRetrieveOptions.ConditionReport){
        //       return this._http.get(this.getReportStyleForCustomerByDealerGroupApi, { search: params }).share().map(
        //         (response: Response) => <ReportStyle[]>response.json()).catch(this.handleError);
        // }
        // if(options == ReportRetrieveOptions.QuoteReport){
        //     return this._http.get(this.getQuoteReportStyleForCustomerByDealerGroupApi, { search: params }).share().map(
        //         (response: Response) => <ReportStyle[]>response.json()).catch(this.handleError);
        // }
        const params = {
          params: new HttpParams().set('dealerGroupId', dealerGroupId.toString())
        };
        if (+options === +ReportRetrieveOptions.ConditionReport) {
              return this._http.get<ReportStyle[]>
              (this.getReportStyleForCustomerByDealerGroupApi, params).pipe(catchError(this.handleError));
        }
        
        if (+options === +ReportRetrieveOptions.QuoteReport) {
            return this._http.get<ReportStyle[]>
            (this.getQuoteReportStyleForCustomerByDealerGroupApi, params).pipe(catchError(this.handleError));
        }

        if (+options === +ReportRetrieveOptions.RopeReport) {
            return this._http.get<ReportStyle[]>
            (this.getRopeReportStyleForCustomerByDealerGroupApi, params).pipe(catchError(this.handleError));
      }

      if (+options === +ReportRetrieveOptions.WearReport) {
        return this._http.get<ReportStyle[]>
        (this.getWearReportStyleForCustomerByDealerGroupApi, params).pipe(catchError(this.handleError));
  }

  if (+options === +ReportRetrieveOptions.WsreReport) {
    return this._http.get<ReportStyle[]>
    (this.getWsreReportStyleForCustomerByDealerGroupApi, params).pipe(catchError(this.handleError));
}
    }

   
    public updateCustomer(customer: UpdateCustomer): Observable<Tuple> {
        // return this._http.post(this.UpdateCustomerApiAddress, customer).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
            return this._http.post<Tuple>(this.UpdateCustomerApiAddress, customer).pipe(catchError(this.handleError));
    }

    public addNewCustomer(newCustomer: NewCustomer): Observable<Tuple> {
        // return this._http.post(this.AddNewCustomerApiAddress, newCustomer).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
            return this._http.post<Tuple>(this.AddNewCustomerApiAddress, newCustomer).pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public getAllCountries(): Observable<CountryVM[]> {
        //   return this._http.get(this.GetAllCountryApiAddress).share().map(
        //   (response: Response) => <CountryVM[]>response.json()).catch (this.handleError);

          return this._http.get<CountryVM[]>(this.GetAllCountryApiAddress).pipe(catchError(this.handleError));
      }
    public validateCustomerNameDealerGroup(dealerId:number,customer:string) : Observable<boolean>  {
        let options = {
            params: new HttpParams().set('customer', customer).set('dealerId', dealerId.toString())
        }
        return this._http.get<boolean>(this.ValidateCustomerName,options).pipe(catchError(this.handleError));
    }

    public validateCustomerNameDealerGroupCustomerID(dealerId:number,customer:string, customerId:number) : Observable<boolean>  {
        let options = {
            params: new HttpParams().set('customer', customer).set('dealerId', dealerId.toString()).set('customerId', customerId.toString())
        }
        return this._http.get<boolean>(this.ValidateCustomerNameEdit,options).pipe(catchError(this.handleError));
    }
}
